(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9189],{

/***/ 98703:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/car-leasing/[manufacturer]/[range]/[derivative]/[vehicleId]/[leaseProfile]/[vehiclePriceId]/config",
      function () {
        return __webpack_require__(28287);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 28287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(34727);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(80969);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ebay_nice_modal_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25362);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14416);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_atomic_ComponentErrorBoundary__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84890);
/* harmony import */ var _components_atomic_PageContainer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29099);
/* harmony import */ var _components_atomic_PageMetaData__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1429);
/* harmony import */ var _components_styleguide_Configurator_PartnerLinkGroup__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80523);
/* harmony import */ var _components_styleguide_Configurator_StickyButtons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45917);
/* harmony import */ var _components_styleguide_Configurator_VehicleImage__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(49870);
/* harmony import */ var _components_styleguide_Configurator_VehicleView__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(84312);
/* harmony import */ var _components_styleguide_Header__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(638);
/* harmony import */ var _components_views_ConfigPage_ConfigChips__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(64403);
/* harmony import */ var _components_views_ConfigPage_ToolbarMobile_ShareAndSave__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(91868);
/* harmony import */ var _components_views_ProfileEditor__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(31699);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(99280);
/* harmony import */ var _lib_hooks_useExperiment__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(46389);
/* harmony import */ var _lib_services_searchService__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(74829);
/* harmony import */ var _lib_services_vehicleService__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(68292);
/* harmony import */ var _lib_utilities_search__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(45425);
/* harmony import */ var _lib_utilities_system__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(70591);
/* harmony import */ var _lib_utilities_vehicle__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(13732);
/* harmony import */ var _store_actions_event__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(61748);
/* harmony import */ var _store_reducers_leaseProfile__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(1093);
/* harmony import */ var _store_reducers_system__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(35371);
/* harmony import */ var _store_reducers_vehicle__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(56664);
/* harmony import */ var _store_selectors_leaseProfile__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(5958);
/* harmony import */ var _store_selectors_system__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(17338);
/* harmony import */ var _store_selectors_user__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(15433);
/* harmony import */ var _store_selectors_vehicle__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(20548);
/* harmony import */ var _types_system__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(16693);
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];






































var ColourOptionsSelector = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 1733).then(__webpack_require__.bind(__webpack_require__, 31733));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31733)
            ];
        }
    }
});
var Title = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 6683).then(__webpack_require__.bind(__webpack_require__, 6683));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6683)
            ];
        }
    }
});
var VehicleDataSpotlightGroup = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 5547).then(__webpack_require__.bind(__webpack_require__, 25547));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25547)
            ];
        }
    }
});
var Gallery = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 2769).then(__webpack_require__.bind(__webpack_require__, 92769));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92769)
            ];
        }
    }
});
var Toolbar = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6261), __webpack_require__.e(1941), __webpack_require__.e(9861)]).then(__webpack_require__.bind(__webpack_require__, 91941));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91941)
            ];
        }
    }
});
var PriceHistory = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2345), __webpack_require__.e(6924), __webpack_require__.e(1337)]).then(__webpack_require__.bind(__webpack_require__, 16924));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16924)
            ];
        }
    }
});
var Review = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 9152).then(__webpack_require__.bind(__webpack_require__, 99152));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99152)
            ];
        }
    }
});
var Specification = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 9485).then(__webpack_require__.bind(__webpack_require__, 9485));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9485)
            ];
        }
    }
});
var PartnerLink = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8456), __webpack_require__.e(6388), __webpack_require__.e(266)]).then(__webpack_require__.bind(__webpack_require__, 90266));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90266)
            ];
        }
    }
});
var Configurator = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(8456), __webpack_require__.e(9878), __webpack_require__.e(425), __webpack_require__.e(9211)]).then(__webpack_require__.bind(__webpack_require__, 29211));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29211)
            ];
        }
    },
    ssr: false
});
var DealsUnavailable = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 2907).then(__webpack_require__.bind(__webpack_require__, 72907));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72907)
            ];
        }
    },
    ssr: false
});
var PartnerHeaderLinks = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 39).then(__webpack_require__.bind(__webpack_require__, 70039));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(70039)
            ];
        }
    },
    ssr: false
});
var AuthenticationModal = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5808), __webpack_require__.e(9161), __webpack_require__.e(8246), __webpack_require__.e(4005)]).then(__webpack_require__.bind(__webpack_require__, 93418));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93418)
            ];
        }
    },
    ssr: false
});
var Interior360Image = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 3868).then(__webpack_require__.bind(__webpack_require__, 63868));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63868)
            ];
        }
    },
    ssr: false
});
var CarConfigPage = function(param) {
    var originalVehicle = param.originalVehicle, originalLeaseProfile = param.originalLeaseProfile, originalReview = param.originalReview, originalStandardOptions = param.originalStandardOptions, originalTechnicalData = param.originalTechnicalData, vehiclePriceId = param.vehiclePriceId;
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z)((0,_lib_hooks_useExperiment__WEBPACK_IMPORTED_MODULE_19__/* .useExperiment */ .a)(), 1), experimentGroup = ref2[0];
    var isDesktop = (0,react_responsive__WEBPACK_IMPORTED_MODULE_6__.useMediaQuery)({
        minWidth: 992
    });
    var visitorKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(_store_selectors_user__WEBPACK_IMPORTED_MODULE_30__/* .selectUsersVisitorKey */ .z_);
    var isFirstRender = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(_store_selectors_system__WEBPACK_IMPORTED_MODULE_29__/* .selectIsFirstRender */ .zm);
    var leaseProfile = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(_store_selectors_leaseProfile__WEBPACK_IMPORTED_MODULE_28__/* .selectLeaseProfile */ .S);
    var paintOptions = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(_store_selectors_vehicle__WEBPACK_IMPORTED_MODULE_31__/* .selectPaintOptions */ .eJ);
    var selectedPaintOption = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(_store_selectors_vehicle__WEBPACK_IMPORTED_MODULE_31__/* .selectSelectedVehiclePaintOption */ .KL);
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), insuranceRef = ref3[0], setInsuranceRef = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(originalVehicle), vehicle = ref4[0], setVehicle = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), selectedVehiclePrice = ref5[0], setSelectedVehiclePrice = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(originalTechnicalData), technicalData = ref6[0], setTechnicalData = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(originalStandardOptions), standardOptions = ref7[0], setStandardOptions = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(originalReview), review = ref8[0], setReview = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]), vehiclePriceTagDictionary = ref9[0], setVehiclePriceTagDictionary = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), showAlert = ref10[0], setShowAlert = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.componentStatus.LOADING */ ._G.componentStatus.LOADING), componentStatus = ref11[0], setComponentStatus = ref11[1];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections.OVERVIEW */ ._G.configPageSections.OVERVIEW), activeSection = ref12[0], setActiveSection = ref12[1];
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), pcpDifference = ref13[0], setPcpDifference = ref13[1];
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.vehicleConfigModes.BEST_VALUE */ ._G.vehicleConfigModes.BEST_VALUE), configMode = ref14[0], setConfigMode = ref14[1];
    var ref15 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), hasConfigModeChanged = ref15[0], setHasConfigModeChanged = ref15[1];
    var ref16 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), hasLeaseProfileChanged = ref16[0], setHasLeaseProfileChanged = ref16[1];
    var ref17 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), openSelector = ref17[0], setOpenSelector = ref17[1];
    var ref18 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.imageStatus.EXTERIOR */ ._G.imageStatus.EXTERIOR), imageStatus = ref18[0], setImageStatus = ref18[1];
    var pageSections = _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections */ ._G.configPageSections;
    var excludedChips = [
        pageSections.EDIT_LEASE,
        pageSections.COLOUR_OPTIONS
    ];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (typeof window.ttq !== "undefined" && selectedVehiclePrice) {
            window.ttq.track("ViewContent", {
                /* eslint-disable */ content_id: "".concat(selectedVehiclePrice.id),
                content_type: "product",
                content_name: "".concat(vehicle.manufacturerName, " ").concat(vehicle.modelName, " ").concat(vehicle.derivativeName),
                /* eslint-enable */ quantity: 1,
                value: selectedVehiclePrice.leaseType === _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .FILTER_LEASE_TYPES_PERSONAL */ .m_ ? (0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_22__/* .addVatToPrice */ .QR)((0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_22__/* .calculateTotalDealCost */ .sU)(selectedVehiclePrice)) : (0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_22__/* .calculateTotalDealCost */ .sU)(selectedVehiclePrice),
                price: "".concat(selectedVehiclePrice.leaseType === _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .FILTER_LEASE_TYPES_PERSONAL */ .m_ ? (0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_22__/* .addVatToPrice */ .QR)(selectedVehiclePrice.monthlyPayment) : selectedVehiclePrice.monthlyPayment.toFixed(2)),
                currency: "GBP"
            });
        }
    }, [
        selectedVehiclePrice,
        vehicle.manufacturerName,
        vehicle.modelName,
        vehicle.derivativeName
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        // If it's the first render on this page then no benefits modal is needed
        if (isFirstRender) {
            dispatch((0,_store_reducers_system__WEBPACK_IMPORTED_MODULE_26__/* .storeShowBenefitsModal */ .x3)(false));
        }
    }, [
        dispatch,
        isFirstRender
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        dispatch((0,_store_reducers_leaseProfile__WEBPACK_IMPORTED_MODULE_25__/* .storeActiveLeaseProfile */ .pu)(originalLeaseProfile));
    }, [
        dispatch,
        originalLeaseProfile
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var doesPaintExist = paintOptions.filter(function(option) {
            return (selectedPaintOption === null || selectedPaintOption === void 0 ? void 0 : selectedPaintOption.id) === option.id;
        });
        if (doesPaintExist.length > 0) {
            dispatch((0,_store_reducers_vehicle__WEBPACK_IMPORTED_MODULE_27__/* .storeExteriorImages */ .df)(selectedPaintOption.images));
        } else {
            var ref, ref1;
            dispatch((0,_store_reducers_vehicle__WEBPACK_IMPORTED_MODULE_27__/* .clearSelectedPaintOption */ .ny)());
            dispatch((0,_store_reducers_vehicle__WEBPACK_IMPORTED_MODULE_27__/* .clearPaintOptionVehicle */ .sO)());
            dispatch((0,_store_reducers_vehicle__WEBPACK_IMPORTED_MODULE_27__/* .storeExteriorImages */ .df)(((ref = originalVehicle.gallery) === null || ref === void 0 ? void 0 : ref.images.filter(function(image) {
                return image.angleType === "EXTERIOR";
            })) || []));
            dispatch((0,_store_reducers_vehicle__WEBPACK_IMPORTED_MODULE_27__/* .storeInteriorImages */ .JN)(((ref1 = originalVehicle.gallery) === null || ref1 === void 0 ? void 0 : ref1.images.filter(function(image) {
                return image.angleType === "INTERIOR";
            })) || []));
        }
    }, [
        dispatch,
        originalVehicle,
        selectedPaintOption,
        paintOptions,
        vehicle
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        // This sets up a timer of 5 seconds before hiding the alert
        if (showAlert) {
            var alertTimer = setTimeout(function() {
                return setShowAlert(false);
            }, 5000);
            return function() {
                clearTimeout(alertTimer);
            };
        }
    }, [
        showAlert
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        // This gets the initial prices for the vehicle
        var payload = {
            vehicleType: _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .FILTER_VEHICLE_TYPES_CARS */ .DC,
            mileage: originalLeaseProfile.mileage,
            term: originalLeaseProfile.term,
            leaseType: originalLeaseProfile.leaseType,
            initialPaymentInMonths: originalLeaseProfile.initialPaymentInMonths,
            stockStatus: originalLeaseProfile.stockStatus,
            range: originalVehicle.range,
            model: originalVehicle.model,
            grouping: 0,
            sorting: _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.vehicleConfigModes.BEST_VALUE */ ._G.vehicleConfigModes.BEST_VALUE
        };
        setComponentStatus(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.componentStatus.LOADING */ ._G.componentStatus.LOADING);
        var getVehiclePrice = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(function(params) {
                var response;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_35__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,_lib_services_vehicleService__WEBPACK_IMPORTED_MODULE_21__/* .getConfiguratorResultsService */ .uJ)(params)
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                2,
                                response
                            ];
                    }
                });
            });
            return function getVehiclePrice(params) {
                return _ref.apply(this, arguments);
            };
        }();
        var storeRecentlyViewed = function(vehiclePrice) {
            var viewedVehicle = {
                vehicle: originalVehicle,
                vehiclePrice: vehiclePrice
            };
            if ((0,_lib_utilities_system__WEBPACK_IMPORTED_MODULE_23__/* .storageAvailable */ .oZ)("localStorage")) {
                var recentlyViewed = JSON.parse(localStorage.getItem(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.localStorageKey.recentlyViewedCars */ ._G.localStorageKey.recentlyViewedCars)) || [];
                var existingIndex = recentlyViewed.findIndex(function(item) {
                    return item.vehicle.id === originalVehicle.id;
                });
                if (existingIndex !== -1) {
                    recentlyViewed.splice(existingIndex, 1);
                }
                recentlyViewed.push(viewedVehicle);
                if (recentlyViewed.length > 24) {
                    recentlyViewed.shift();
                }
                localStorage.setItem(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.localStorageKey.recentlyViewedCars */ ._G.localStorageKey.recentlyViewedCars, JSON.stringify(recentlyViewed));
            }
        };
        var selectVehiclePrice = function(results) {
            var selectedDeal = results.filter(function(item) {
                return item.vehiclePrice.id === vehiclePriceId;
            });
            var selectedVehicle = results.filter(function(item) {
                return item.vehiclePrice.vehicleId === originalLeaseProfile.vehicleId;
            });
            var vehiclePrice = selectedDeal.length > 0 ? selectedDeal[0].vehiclePrice : selectedVehicle.length > 0 ? selectedVehicle[0].vehiclePrice : results[0].vehiclePrice;
            var eventData = (0,_lib_utilities_vehicle__WEBPACK_IMPORTED_MODULE_24__/* .generateEventPayloadForVehiclePrice */ .s6)(vehiclePrice);
            if (!!vehiclePrice && !!originalVehicle) {
                storeRecentlyViewed(vehiclePrice);
            }
            setSelectedVehiclePrice(vehiclePrice);
            dispatch((0,_store_actions_event__WEBPACK_IMPORTED_MODULE_36__/* .postAnalyticsEvent */ .gR)({
                event: _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.eventTypes.vehicleConfigRequest */ ._G.eventTypes.vehicleConfigRequest,
                payload: eventData
            }));
            setVehiclePriceTagDictionary(results.flatMap(function(item) {
                return item.vehiclePriceTags;
            }));
        };
        getVehiclePrice((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z)({
            vehicleId: originalLeaseProfile.vehicleId
        }, payload)).then(function(res) {
            if (res.results.length > 0) {
                selectVehiclePrice(res.results);
            } else {
                getVehiclePrice(payload).then(function(backup) {
                    if (backup.results.length > 0) {
                        selectVehiclePrice(backup.results);
                    }
                });
            }
        }).finally(function() {
            setComponentStatus(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.componentStatus.COMPLETE */ ._G.componentStatus.COMPLETE);
        });
    }, [
        originalLeaseProfile,
        originalVehicle,
        vehiclePriceId,
        dispatch
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        // This gets the prices for the vehicle when config mode is changed
        if (hasConfigModeChanged) {
            setComponentStatus(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.componentStatus.LOADING */ ._G.componentStatus.LOADING);
            var getVehiclePrice = function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(function(params) {
                    var response;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_35__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0,_lib_services_vehicleService__WEBPACK_IMPORTED_MODULE_21__/* .getConfiguratorResultsService */ .uJ)(params)
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function getVehiclePrice(params) {
                    return _ref.apply(this, arguments);
                };
            }();
            getVehiclePrice({
                vehicleType: _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .FILTER_VEHICLE_TYPES_CARS */ .DC,
                mileage: leaseProfile.mileage,
                term: leaseProfile.term,
                leaseType: leaseProfile.leaseType,
                initialPaymentInMonths: leaseProfile.initialPaymentInMonths,
                stockStatus: leaseProfile.stockStatus,
                range: originalVehicle.range,
                model: originalVehicle.model,
                grouping: 0,
                sorting: configMode
            }).then(function(res) {
                if (res.results.length > 0) {
                    var vehiclePrice = res.results[0].vehiclePrice;
                    setSelectedVehiclePrice(vehiclePrice);
                    setVehiclePriceTagDictionary(res.results.flatMap(function(item) {
                        return item.vehiclePriceTags;
                    }));
                    if (vehiclePrice.vehicleId !== leaseProfile.vehicleId) {
                        dispatch((0,_store_reducers_leaseProfile__WEBPACK_IMPORTED_MODULE_25__/* .storeActiveLeaseProfile */ .pu)({
                            mileage: vehiclePrice.mileage,
                            term: vehiclePrice.term,
                            leaseType: vehiclePrice.leaseType,
                            initialPaymentInMonths: vehiclePrice.initialPaymentInMonths,
                            stockStatus: vehiclePrice.stockStatus,
                            vehicleId: vehiclePrice.vehicleId
                        }));
                    }
                }
            }).finally(function() {
                setHasConfigModeChanged(false);
                setComponentStatus(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.componentStatus.COMPLETE */ ._G.componentStatus.COMPLETE);
            });
        }
    }, [
        configMode,
        leaseProfile,
        originalVehicle,
        hasConfigModeChanged,
        dispatch
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        // This gets the prices for the vehicle when lease profile mode has changed
        if (hasLeaseProfileChanged) {
            setComponentStatus(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.componentStatus.LOADING */ ._G.componentStatus.LOADING);
            var getVehiclePrice = function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(function(params) {
                    var response;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_35__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0,_lib_services_vehicleService__WEBPACK_IMPORTED_MODULE_21__/* .getConfiguratorResultsService */ .uJ)(params)
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function getVehiclePrice(params) {
                    return _ref.apply(this, arguments);
                };
            }();
            getVehiclePrice({
                vehicleType: _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .FILTER_VEHICLE_TYPES_CARS */ .DC,
                mileage: leaseProfile.mileage,
                term: leaseProfile.term,
                leaseType: leaseProfile.leaseType,
                initialPaymentInMonths: leaseProfile.initialPaymentInMonths,
                stockStatus: leaseProfile.stockStatus,
                range: vehicle.range,
                model: vehicle.model,
                vehicleId: leaseProfile.vehicleId,
                grouping: 0,
                sorting: configMode
            }).then(function(res) {
                if (res.results.length > 0) {
                    var vehiclePrice = res.results[0].vehiclePrice;
                    setSelectedVehiclePrice(vehiclePrice);
                    setVehiclePriceTagDictionary(res.results.flatMap(function(item) {
                        return item.vehiclePriceTags;
                    }));
                }
            }).finally(function() {
                setHasLeaseProfileChanged(false);
                setComponentStatus(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.componentStatus.COMPLETE */ ._G.componentStatus.COMPLETE);
            });
        }
    }, [
        configMode,
        leaseProfile,
        vehicle,
        hasLeaseProfileChanged,
        dispatch
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        // This updates the vehicle object if the selectedVehiclePrice vehicleId differs
        if (!!selectedVehiclePrice && selectedVehiclePrice.vehicleId !== vehicle.id) {
            var getVehicle = function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(function(params) {
                    var response;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_35__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0,_lib_services_vehicleService__WEBPACK_IMPORTED_MODULE_21__/* .getVehicleService */ .qg)(params)
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                });
                return function getVehicle(params) {
                    return _ref.apply(this, arguments);
                };
            }();
            getVehicle({
                id: selectedVehiclePrice.vehicleId
            }).then(function(res) {
                var ref;
                setVehicle(res);
                dispatch((0,_store_reducers_vehicle__WEBPACK_IMPORTED_MODULE_27__/* .storeExteriorImages */ .df)(((ref = res.gallery) === null || ref === void 0 ? void 0 : ref.images) || []));
            });
        }
    }, [
        selectedVehiclePrice,
        vehicle.id,
        dispatch
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        // This fetches technical data if vehicle id changes
        var getNewVehicleData = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(function(params) {
                var standardOptions, technicalData;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_35__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,_lib_services_vehicleService__WEBPACK_IMPORTED_MODULE_21__/* .getVehicleStandardOptionsService */ .HA)({
                                    id: params.id,
                                    vehicleType: _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .FILTER_VEHICLE_TYPES_CARS */ .DC
                                })
                            ];
                        case 1:
                            standardOptions = _state.sent();
                            return [
                                4,
                                (0,_lib_services_vehicleService__WEBPACK_IMPORTED_MODULE_21__/* .getVehicleTechnicalDataService */ .Kr)({
                                    id: params.id
                                })
                            ];
                        case 2:
                            technicalData = _state.sent();
                            return [
                                2,
                                {
                                    technicalData: technicalData,
                                    standardOptions: standardOptions
                                }
                            ];
                    }
                });
            });
            return function getNewVehicleData(params) {
                return _ref.apply(this, arguments);
            };
        }();
        getNewVehicleData({
            id: vehicle.id
        }).then(function(res) {
            setTechnicalData(res.technicalData);
            setStandardOptions(res.standardOptions);
        });
    }, [
        vehicle.id
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        // This fetches paint data if vehicle id changes
        var getNewVehiclePaintData = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(function(vehicleId) {
                var paintOptions;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_35__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,_lib_services_vehicleService__WEBPACK_IMPORTED_MODULE_21__/* .getVehiclePaintService */ .HU)({
                                    vehicleId: vehicleId
                                })
                            ];
                        case 1:
                            paintOptions = _state.sent();
                            return [
                                2,
                                paintOptions
                            ];
                    }
                });
            });
            return function getNewVehiclePaintData(vehicleId) {
                return _ref.apply(this, arguments);
            };
        }();
        getNewVehiclePaintData(vehicle.id).then(function(res) {
            var filteredResults = res.filter(function(item) {
                return item.id !== null;
            });
            dispatch((0,_store_reducers_vehicle__WEBPACK_IMPORTED_MODULE_27__/* .storePaintOptions */ .rJ)(filteredResults));
        });
    }, [
        vehicle.id,
        dispatch
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (selectedVehiclePrice) {
            (0,_lib_services_searchService__WEBPACK_IMPORTED_MODULE_20__/* .getPcpPricesForPersonalService */ .TC)({
                term: selectedVehiclePrice.term,
                mileage: selectedVehiclePrice.mileage,
                initialPaymentInMonths: selectedVehiclePrice.initialPaymentInMonths,
                vehicleId: vehicle.id
            }).then(function(res) {
                var difference = (0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_22__/* .addVatToPrice */ .QR)(res.monthlyPayment) - (0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_22__/* .addVatToPrice */ .QR)(selectedVehiclePrice.monthlyPayment);
                setPcpDifference(difference);
            }).catch(function() {
                setPcpDifference(null);
            });
        }
    }, [
        vehicle.id,
        selectedVehiclePrice
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        // This fetches review data if vehicle id changes
        var getVehicleReviewData = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)(function(params) {
                var review;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_35__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,_lib_services_vehicleService__WEBPACK_IMPORTED_MODULE_21__/* .getVehicleReviewService */ .KR)({
                                    id: params.id
                                })
                            ];
                        case 1:
                            review = _state.sent();
                            return [
                                2,
                                review
                            ];
                    }
                });
            });
            return function getVehicleReviewData(params) {
                return _ref.apply(this, arguments);
            };
        }();
        getVehicleReviewData({
            id: vehicle.id
        }).then(function(res) {
            setReview(res);
        }).catch(function() {
            setReview(null);
        });
    }, [
        vehicle.id
    ]);
    var onOtherButtonClick = function(buttonPosition, type) {
        (0,_lib_utilities_vehicle__WEBPACK_IMPORTED_MODULE_24__/* .addToDataLayer */ .Bk)({
            event: type.toLowerCase().split("_").join("-"),
            action: "button-click",
            position: buttonPosition,
            experimentGroup: experimentGroup
        });
        dispatch((0,_store_actions_event__WEBPACK_IMPORTED_MODULE_36__/* .postAnalyticsEvent */ .gR)({
            event: type.toUpperCase().split("-").join("_"),
            payload: {
                position: buttonPosition
            }
        }));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (visitorKey) {
            var ref = Buffer.from(JSON.stringify({
                vp: selectedVehiclePrice === null || selectedVehiclePrice === void 0 ? void 0 : selectedVehiclePrice.id,
                vi: vehicle.id,
                vk: visitorKey.substr(visitorKey.length - 7),
                ts: (0,_lib_utilities_system__WEBPACK_IMPORTED_MODULE_23__/* .createUnixTimestampForCurrentTime */ .uO)()
            })).toString("base64");
            setInsuranceRef(ref);
        }
    }, [
        visitorKey,
        selectedVehiclePrice,
        vehicle,
        technicalData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (activeSection !== _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections.OVERVIEW */ ._G.configPageSections.OVERVIEW) {
            setImageStatus(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.imageStatus.EXTERIOR */ ._G.imageStatus.EXTERIOR);
        }
    }, [
        activeSection
    ]);
    var onLoginButtonClick = function() {
        _ebay_nice_modal_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"].show */ .ZP.show(AuthenticationModal, {
            initialStatus: _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .STATUS_PRE_REGISTER */ .k_
        });
    };
    var onNavigationButtonClick = function(chipId) {
        var id = chipId.toString();
        setActiveSection(id);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atomic_PageMetaData__WEBPACK_IMPORTED_MODULE_9__/* .PageMetaData */ .S, {
                vehicle: vehicle,
                leaseProfile: leaseProfile,
                title: "".concat(vehicle.manufacturerName, " ").concat(vehicle.modelName, " ").concat(vehicle.derivativeName, " Lease: ").concat(originalLeaseProfile.term, " Month ").concat(originalLeaseProfile.mileage, " Miles ").concat(originalLeaseProfile.initialPaymentInMonths, " Months Upfront"),
                description: "Lease a ".concat(vehicle.manufacturerName, " ").concat(vehicle.modelName, " ").concat(vehicle.derivativeName, " Over ").concat(originalLeaseProfile.term, " Months with ").concat(leaseProfile.mileage, " Miles PA and ").concat(originalLeaseProfile.initialPaymentInMonths, " Months Upfront Today Via LeaseLoco"),
                pageUrl: router.asPath,
                canonical: "".concat("https://www.leaseloco.com", "/car-leasing/").concat((0,_lib_utilities_vehicle__WEBPACK_IMPORTED_MODULE_24__/* .getUrlReadyString */ .oh)(vehicle.manufacturerName), "/").concat((0,_lib_utilities_vehicle__WEBPACK_IMPORTED_MODULE_24__/* .getUrlReadyString */ .oh)(vehicle.rangeName)),
                noIndex: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Header__WEBPACK_IMPORTED_MODULE_14__/* .Header */ .h, {
                backButtonUrl: "/car-leasing/search",
                hideNav: true,
                navDesktopCenter: leaseProfile.vehicleId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_views_ProfileEditor__WEBPACK_IMPORTED_MODULE_17__/* .ProfileEditor */ .h, {
                    leaseProfile: leaseProfile,
                    vehicleType: _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .FILTER_VEHICLE_TYPES_CARS */ .DC,
                    setHasLeaseProfileChanged: setHasLeaseProfileChanged,
                    openSelectorOverride: openSelector,
                    setOpenSelectorOverride: function(arg) {
                        return setOpenSelector(arg);
                    }
                }),
                navMobileRight: selectedVehiclePrice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_views_ConfigPage_ToolbarMobile_ShareAndSave__WEBPACK_IMPORTED_MODULE_16__/* .ShareAndSave */ .w, {
                    selectedVehiclePrice: selectedVehiclePrice,
                    onLoginButtonClick: onLoginButtonClick,
                    isConfigPage: true
                }),
                isLogoSticky: activeSection === _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections.OVERVIEW */ ._G.configPageSections.OVERVIEW || activeSection === _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections.COLOUR_OPTIONS */ ._G.configPageSections.COLOUR_OPTIONS,
                theme: _types_system__WEBPACK_IMPORTED_MODULE_32__/* .Theme.light */ .Q2.light,
                backgroundColor: "backdrop",
                isConfigPage: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "container--config-image".concat(imageStatus.includes(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.imageStatus.INTERIOR */ ._G.imageStatus.INTERIOR) ? " no-padding" : ""),
                children: [
                    imageStatus.includes(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.imageStatus.EXTERIOR */ ._G.imageStatus.EXTERIOR) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Configurator_VehicleImage__WEBPACK_IMPORTED_MODULE_12__/* .VehicleImage */ .o, {
                        vehicle: vehicle,
                        setActiveSection: setActiveSection,
                        activeSection: activeSection
                    }),
                    imageStatus.includes(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.imageStatus.INTERIOR */ ._G.imageStatus.INTERIOR) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Interior360Image, {
                        path: vehicle.gallery.interior360Path,
                        imageStatus: imageStatus
                    }),
                    (activeSection === _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections.OVERVIEW */ ._G.configPageSections.OVERVIEW || activeSection === _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections.COLOUR_OPTIONS */ ._G.configPageSections.COLOUR_OPTIONS) && (vehicle === null || vehicle === void 0 ? void 0 : (ref = vehicle.gallery) === null || ref === void 0 ? void 0 : ref.interior360Path) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Configurator_StickyButtons__WEBPACK_IMPORTED_MODULE_11__/* .StickyButtons */ .L, {
                        imageStatus: imageStatus,
                        setImageStatus: setImageStatus,
                        openSelector: openSelector,
                        setActiveSection: setActiveSection,
                        activeSection: activeSection,
                        vehicle: vehicle
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container-fluid container--grey container--config-page",
                children: [
                    !isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "config-page__title",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                                vehicle: vehicle,
                                selectedVehiclePrice: selectedVehiclePrice
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "config-page__spotlight",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VehicleDataSpotlightGroup, {
                                    technicalData: technicalData,
                                    vehicleFuelType: vehicle.fuelType,
                                    includeLabels: [
                                        "Range",
                                        "Charging time",
                                        "0-62",
                                        "Boot space"
                                    ],
                                    mobileDataPoints: [
                                        "Range",
                                        "Charging time",
                                        "Fuel consumption",
                                        "0-62",
                                        "Boot space", 
                                    ],
                                    isList: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atomic_PageContainer__WEBPACK_IMPORTED_MODULE_8__/* .PageContainer */ ._, {
                        containerClass: "container--config",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                            className: "config-page__vehicle-config",
                            children: [
                                isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "config-page__content".concat(imageStatus.includes(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.imageStatus.INTERIOR */ ._G.imageStatus.INTERIOR) ? " interior-view" : ""),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                                            vehicle: vehicle,
                                            selectedVehiclePrice: selectedVehiclePrice,
                                            isSticky: activeSection === _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections.OVERVIEW */ ._G.configPageSections.OVERVIEW || activeSection === _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections.COLOUR_OPTIONS */ ._G.configPageSections.COLOUR_OPTIONS
                                        }),
                                        (activeSection === _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections.OVERVIEW */ ._G.configPageSections.OVERVIEW || activeSection === _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections.COLOUR_OPTIONS */ ._G.configPageSections.COLOUR_OPTIONS || activeSection === _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections.SPECIFICATION */ ._G.configPageSections.SPECIFICATION) && imageStatus.includes(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.imageStatus.EXTERIOR */ ._G.imageStatus.EXTERIOR) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "config-page__vehicle-view ".concat(activeSection !== _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections.SPECIFICATION */ ._G.configPageSections.SPECIFICATION ? "config-page__vehicle-view--sticky" : ""),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Configurator_VehicleView__WEBPACK_IMPORTED_MODULE_13__/* .VehicleView */ ._, {
                                                    vehicle: vehicle,
                                                    technicalData: technicalData,
                                                    setActiveSection: setActiveSection,
                                                    activeSection: activeSection
                                                }),
                                                (vehicle === null || vehicle === void 0 ? void 0 : (ref1 = vehicle.gallery) === null || ref1 === void 0 ? void 0 : ref1.interior360Path) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Configurator_StickyButtons__WEBPACK_IMPORTED_MODULE_11__/* .StickyButtons */ .L, {
                                                    imageStatus: imageStatus,
                                                    setImageStatus: setImageStatus,
                                                    openSelector: openSelector,
                                                    setActiveSection: setActiveSection,
                                                    activeSection: activeSection,
                                                    vehicle: vehicle
                                                })
                                            ]
                                        }),
                                        activeSection === _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections.OVERVIEW */ ._G.configPageSections.OVERVIEW && imageStatus.includes(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.imageStatus.INTERIOR */ ._G.imageStatus.INTERIOR) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "config-page__vehicle-view config-page__vehicle-view--sticky",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Interior360Image, {
                                                    path: vehicle.gallery.interior360Path,
                                                    imageStatus: imageStatus
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Configurator_StickyButtons__WEBPACK_IMPORTED_MODULE_11__/* .StickyButtons */ .L, {
                                                    imageStatus: imageStatus,
                                                    setImageStatus: setImageStatus,
                                                    openSelector: openSelector,
                                                    setActiveSection: setActiveSection,
                                                    activeSection: activeSection,
                                                    vehicle: vehicle
                                                })
                                            ]
                                        }),
                                        activeSection === _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections.SPECIFICATION */ ._G.configPageSections.SPECIFICATION && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Specification, {
                                            vehicle: vehicle,
                                            technicalData: technicalData,
                                            standardOptions: standardOptions
                                        }),
                                        activeSection === _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections.PRICE_HISTORY */ ._G.configPageSections.PRICE_HISTORY && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PriceHistory, {
                                            selectedVehiclePrice: selectedVehiclePrice,
                                            pcpDifference: pcpDifference
                                        }),
                                        activeSection === _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections.GALLERY */ ._G.configPageSections.GALLERY && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Gallery, {
                                            vehicle: vehicle,
                                            setActiveSection: setActiveSection
                                        }),
                                        activeSection === _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections.REVIEW */ ._G.configPageSections.REVIEW && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Review, {
                                            review: review,
                                            vehicle: vehicle
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "config-page__config",
                                    children: [
                                        !selectedVehiclePrice && componentStatus !== _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.componentStatus.LOADING */ ._G.componentStatus.LOADING && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DealsUnavailable, {
                                            vehicle: vehicle
                                        }),
                                        !!selectedVehiclePrice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_atomic_ComponentErrorBoundary__WEBPACK_IMPORTED_MODULE_7__/* .ComponentErrorBoundary */ .O, {
                                            children: [
                                                isDesktop ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PartnerHeaderLinks, {
                                                    onOtherButtonClick: onOtherButtonClick,
                                                    insuranceRef: insuranceRef,
                                                    vehicleType: selectedVehiclePrice.vehicleType
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_views_ConfigPage_ConfigChips__WEBPACK_IMPORTED_MODULE_15__.ConfigChips, {
                                                    pageSections: pageSections,
                                                    excludedChips: excludedChips,
                                                    onNavigationButtonClick: onNavigationButtonClick,
                                                    isSticky: true
                                                }),
                                                activeSection !== _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections.COLOUR_OPTIONS */ ._G.configPageSections.COLOUR_OPTIONS && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Configurator, {
                                                    setSelectedVehiclePrice: setSelectedVehiclePrice,
                                                    selectedVehiclePrice: selectedVehiclePrice,
                                                    standardOptions: standardOptions,
                                                    technicalData: technicalData,
                                                    setShowAlert: setShowAlert,
                                                    vehiclePriceTagDictionary: vehiclePriceTagDictionary,
                                                    setVehiclePriceTagDictionary: setVehiclePriceTagDictionary,
                                                    configMode: configMode,
                                                    setConfigMode: setConfigMode,
                                                    setHasConfigModeChanged: setHasConfigModeChanged,
                                                    pcpDifference: pcpDifference,
                                                    setOpenSelector: setOpenSelector,
                                                    setActiveSection: setActiveSection,
                                                    onOtherButtonClick: onOtherButtonClick,
                                                    insuranceRef: insuranceRef
                                                }),
                                                activeSection === _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections.COLOUR_OPTIONS */ ._G.configPageSections.COLOUR_OPTIONS && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ColourOptionsSelector, {
                                                    vehicle: vehicle,
                                                    setActiveSection: setActiveSection
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_styleguide_Configurator_PartnerLinkGroup__WEBPACK_IMPORTED_MODULE_10__/* .PartnerLinkGroup */ .u, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PartnerLink, {
                                                            icon: "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.imageHost.assets */ ._G.imageHost.assets, "/branding/msm-circle.svg"),
                                                            heading: "Compare car insurance quotes",
                                                            body: "With deals from over 170 providers, MoneySuperMarket helps you compare car insurance prices to find the policy that is right for you.",
                                                            link: "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.insuranceUrl.dealPage */ ._G.insuranceUrl.dealPage, "?utm_source=leaseloco&utm_medium=affiliate&utm_campaign=config-middle&ref1=config-middle"),
                                                            linkText: "Get a quote",
                                                            type: _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.promotionalType.INSURANCE */ ._G.promotionalType.INSURANCE,
                                                            onClick: onOtherButtonClick
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PartnerLink, {
                                                            icon: "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.imageHost.assets */ ._G.imageHost.assets, "/branding/motorway-icon-2025.svg"),
                                                            heading: "Need to value your car?",
                                                            body: "7,500+ dealers compete to buy your car. 84% of customers get more money with Motorway.<sup>1</sup>",
                                                            link: "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.sellYourVehicleUrl.dealPage */ ._G.sellYourVehicleUrl.dealPage, "/partner/leaseloco?utm_source=leaseloco&utm_medium=affiliate&utm_campaign=config-middle"),
                                                            linkText: "Value your car",
                                                            type: _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.promotionalType.SELL_YOUR_VEHICLE */ ._G.promotionalType.SELL_YOUR_VEHICLE,
                                                            onClick: onOtherButtonClick
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            selectedVehiclePrice !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Toolbar, {
                activeSection: activeSection,
                setActiveSection: setActiveSection,
                selectedVehiclePrice: selectedVehiclePrice,
                theme: activeSection === _lib_constants__WEBPACK_IMPORTED_MODULE_18__/* .constants.configPageSections.GALLERY */ ._G.configPageSections.GALLERY ? _types_system__WEBPACK_IMPORTED_MODULE_32__/* .Theme.dark */ .Q2.dark : _types_system__WEBPACK_IMPORTED_MODULE_32__/* .Theme.light */ .Q2.light,
                vehicle: vehicle,
                technicalData: technicalData,
                standardOptions: standardOptions,
                pcpDifference: pcpDifference,
                review: review,
                setHasLeaseProfileChanged: setHasLeaseProfileChanged,
                setOpenSelector: setOpenSelector,
                openSelector: openSelector,
                imageStatus: imageStatus
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (CarConfigPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2302,1852,5675,4660,8611,535,50,2367,9990,638,1429,7385,3956,4361,3922,9774,2888,179], function() { return __webpack_exec__(98703); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);